var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconGlobeB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 6.65076 11.7092",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.28507 2.07446C6.28507 1.34613 6.41427 0.647462 6.65076 0H4.33067C1.94274 0 0 1.94274 0 4.33067V9.11082C0 10.5436 1.16561 11.7092 2.5984 11.7092H6.43408C6.33792 11.438 6.28507 11.1467 6.28507 10.843V2.07446Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconGlobeB);
export default __webpack_public_path__ + "static/media/trusted-icon-globe-b.a482381d572bced6633d3921152d6802.svg";
export { ForwardRef as ReactComponent };